import { login as E, getConversationHistory as R, deleteUser as b, getUser as M, createFile as T, deleteMessage as U, getMessage as $, updateConversation as S, createMessage as x, listConversationMessages as _, listConversations as A, deleteConversation as I, getConversation as w, createConversation as N } from "./hitl-client3.js";
import { client as v } from "./hitl-client4.js";
import { EventSource as k } from "./hitl-client5.js";
import { createEventEmitter as q } from "./hitl-client6.js";
const n = (s) => s.data, F = (s, i) => {
  const l = (...t) => s.on(...t);
  return new Proxy(l, {
    get: (t, r) => r === "on" ? s.on : r === "disconnect" ? i : r === "cleanup" ? s.cleanup : Reflect.get(t, r)
  });
}, m = {
  throwOnError: !0
}, X = ({
  webhookId: s,
  accessToken: i,
  apiUrl: l
}) => {
  const t = `${l || v.getConfig().baseUrl}/${s}`, r = {
    ...m,
    baseUrl: t
  };
  return E({ ...r, headers: { "x-access-token": i }, body: {} }).then(n);
}, Y = ({
  userKey: s,
  webhookId: i,
  apiUrl: l
}) => {
  const t = {
    "x-user-key": s
  }, r = `${l || v.getConfig().baseUrl}/${i}`, o = {
    ...m,
    baseUrl: r
  };
  return {
    createConversation: () => N({ ...o, headers: t, body: {} }).then(n),
    getConversation: ({ conversationId: e }) => w({ ...o, headers: t, path: { id: e } }).then(n),
    deleteConversation: ({ conversationId: e }) => I({ ...o, headers: t, path: { id: e } }).then(n),
    listConversations: ({ nextToken: e }) => A({ ...o, headers: t, query: { nextToken: e } }).then(n),
    listConversationMessages: ({ conversationId: e, nextToken: g }) => _({
      ...o,
      headers: t,
      path: { id: e },
      query: { nextToken: g }
    }).then(n),
    createMessage: (e) => x({ ...o, headers: t, body: e }).then(n),
    updateConversation: ({ conversationId: e, ...g }) => S({ ...o, headers: t, body: g, path: { id: e } }).then(n),
    getMessage: ({ messageId: e }) => $({ ...o, headers: t, path: { id: e } }).then(n),
    deleteMessage: ({ messageId: e }) => U({ ...o, headers: t, path: { id: e } }).then(n),
    createFile: (e) => T({ ...o, headers: t, body: e }).then(n),
    getUser: () => M({ ...o, headers: t }).then(n),
    deleteUser: () => b({ ...o, headers: t }).then(n),
    getConversationHistory: ({ conversationId: e }) => R({ ...o, headers: t, path: { id: e } }).then(n),
    listenConversation: ({ conversationId: e }) => {
      let f = 0, h = null, a = null;
      const d = q(), p = () => {
        h && (clearTimeout(h), h = null), a && (a.close(), a = null);
      }, C = () => {
        a && a.close();
        const y = `${r}/conversations/${e}/listen`;
        a = new k(y, {
          fetch: (u, c) => fetch(u, {
            ...c,
            headers: {
              ...c == null ? void 0 : c.headers,
              ...t,
              timeout: "60_000"
            }
          })
        }), a.onopen = () => d.emit("open"), a.onerror = (u) => {
          d.emit("error", u), f < 10 && (f++, h = setTimeout(() => C(), 3e3));
        }, a.onmessage = (u) => {
          const c = H(u.data);
          d.emit(c.type, c.data);
        };
      };
      return C(), F(d, p);
    }
  };
}, H = (s) => {
  try {
    return JSON.parse(s);
  } catch {
    return s;
  }
};
export {
  Y as createClient,
  X as login
};
